import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Carousel } from "../Stack/Carousel.js";
export function BubbleMenu({ children, className, as, carousel, ...rest }) {
    const Component = as ?? "ul";
    if (carousel.config?.count > 6) {
        return (_jsx(Carousel, { as: Component, ...carousel, className: classNames(
            // The carousel's own column rules win over cvr-carousel-columns-overflow,
            // so hand it the bubble column count and drop its half-visible sibling.
            "cvr-carousel-columns-overflow [--cvr-stack-columns:var(--visible-columns)] [--cvr-stack-visible-sibling:0]", className), ...rest, children: children }));
    }
    return (_jsx(Component, { className: classNames("cvr-carousel-columns-overflow", className), ...rest, children: children }));
}
